/** Background list refresh interval (ms). */
export const FETCH_INTERVAL_MS = 60_000;
